import { render } from "./SubtitleViewer.vue?vue&type=template&id=c54bd324&scoped=true"
import script from "./SubtitleViewer.vue?vue&type=script&lang=ts"
export * from "./SubtitleViewer.vue?vue&type=script&lang=ts"

import "./SubtitleViewer.vue?vue&type=style&index=0&id=c54bd324&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c54bd324"

export default script